import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpService, GET, Adapter } from "@royalty/httpclient";

@Injectable()
export class PaymentService extends HttpService {
	/**
	 * payment
	 */
	@GET("payment/list")
	@Adapter(null, { isAdmin: false })
	getPayments(): Observable<any> {
		return null;
	}
}
